import { useEffect, useState } from 'react';
import { useMobile } from '@shared/hooks';

export const useMobileVisibilityFilter = (isFilterOn: boolean) => {
  const [mobileWithFilterOn, setMobileWithFilterOn] = useState(false);
  const { isMobile } = useMobile();

  useEffect(() => {
    if (isFilterOn && isMobile) {
      setMobileWithFilterOn(true);
    } else {
      setMobileWithFilterOn(false);
    }
  }, [isMobile, isFilterOn]);

  return {
    mobileWithFilterOn,
    setMobileWithFilterOn,
  };
};
